module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-61-dff50e01e600f9d80c2a33e75f8f76b1.svg";